// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITriggerDto
 */
export interface ITriggerDto {
    /**
     * 
     * @type {number}
     * @memberof ITriggerDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITriggerDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ITriggerDto
     * @deprecated
     */
    type?: ITriggerDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ITriggerDto
     */
    trigger_category_type?: ITriggerDtoTriggerCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ITriggerDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITriggerDto
     */
    organization_path?: string;
}

/**
* @export
* @enum {string}
*/
export enum ITriggerDtoTypeEnum {
    EXTERNAL_DEDUCTIBLE_MET = 'EXTERNAL_DEDUCTIBLE_MET',
    PLAN_DEDUCTIBLE_MET = 'PLAN_DEDUCTIBLE_MET',
    MEMBER_DEDUCTIBLE_MET = 'MEMBER_DEDUCTIBLE_MET',
    EMBEDDED_DEDUCTIBLE_MET = 'EMBEDDED_DEDUCTIBLE_MET'
}
/**
* @export
* @enum {string}
*/
export enum ITriggerDtoTriggerCategoryTypeEnum {
    EXTERNAL = 'EXTERNAL',
    FAMILY = 'FAMILY',
    EMBEDDED = 'EMBEDDED'
}


/**
 * Check if a given object implements the ITriggerDto interface.
 */
export function instanceOfITriggerDto(value: object): value is ITriggerDto {
    return true;
}

export function ITriggerDtoFromJSON(json: any): ITriggerDto {
    return ITriggerDtoFromJSONTyped(json, false);
}

export function ITriggerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITriggerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'trigger_category_type': json['trigger_category_type'] == null ? undefined : json['trigger_category_type'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
    };
}

export function ITriggerDtoToJSON(json: any): ITriggerDto {
    return ITriggerDtoToJSONTyped(json, false);
}

export function ITriggerDtoToJSONTyped(value?: ITriggerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'trigger_category_type': value['trigger_category_type'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
    };
}

